import type { OAuthProvider, SignupRequest, Token } from './schemas'
import { authApi } from './api'
import type { Account } from '@/modules/accounts/schemas'
import { accountsApi } from '@/modules/accounts/api'

export class AuthService {
  async login(credentials: SignupRequest): Promise<Token> {
    return authApi.signup(credentials)
  }

  async getOAuthRedirect(provider: OAuthProvider): Promise<{
    url: string
    state: string
    nonce: string
  }> {
    return authApi.getOAuthRedirect(provider)
  }

  async handleOAuthCallback(
    provider: OAuthProvider,
    code: string,
    state: string,
    nonce?: string
  ): Promise<Token> {
    return authApi.handleOAuthCallback(provider, code, state, nonce)
  }

  async fetchAccount(): Promise<Account> {
    return accountsApi.getMe()
  }

  async deleteAccount(): Promise<void> {
    await accountsApi.deleteMe()
  }
}

export const authService = new AuthService()
